import React, {useEffect, useMemo, useState} from 'react';
import {Col, Space} from 'antd';
import {EditOutlined} from '@ant-design/icons';
import {useSelector} from 'react-redux';

// Store
import {useAppDispatch} from '../../../store/store';
import * as userStoreMapSelectors from '../../../store/redux/selectors/userStoreMapSelectors';
import {getParams} from '../../../store/redux/actions/userStoreMapActions';

// Types
import {UserStoreMapType, UserStorePaginationType} from '../../../types/userStoreMapTypes';

// Components and Subcomponents
import TableComponent from '../../subComponents/TableComponent';
import FiltersComponent from '../../subComponents/FiltersComponent';

// Functions and Constants
import {getFilterParameters, getTableColumns} from '../../../utils/componentsUtils';


type PropsType = {
  onToggleModal: (visible: boolean, userStoreMapToEdit?: UserStoreMapType) => void;
}
const UserStoreMapsTable = (props: PropsType) => {
  const dispatch = useAppDispatch();
  const { onToggleModal } = props;
  const [paginationData, setPaginationData] = useState<UserStorePaginationType>({
    pagination: {page: 1, size: 10},
    filter: {}
  });
  const [list, setList] = useState<UserStoreMapType[]>([]);
  const { rows, count, size, page } = useSelector(userStoreMapSelectors.allUserStoreMapsSelector);
  const { stores } = useSelector(userStoreMapSelectors.userStoreMapParamsSelector);
  const filterParameters = useMemo(() => {
      const params = getFilterParameters('userStores');
  
      return params.map((filter) => {
        if (filter.fieldName === 'storeId') {
          return {
            ...filter,
            list: stores
          };
        }
  
        return filter;
      });
    }, [stores]);

  useEffect(() => {
    dispatch(getParams(paginationData));
  }, [paginationData]);

  useEffect(() => {
    const newList: UserStoreMapType[] = rows.flatMap((userStoreMap) => [
      {
        ...userStoreMap,
        storeName: stores.find((store) => store.id === userStoreMap.storeId)?.value as string,
      }
    ]);

    setList(newList);
  }, [stores, rows]);

  const handleFormModal = (visible: boolean, userStoreMapId?: string) => {
    const userStoreMapToEdit = rows.find(userStoreMap => userStoreMap.userStoreMapId === userStoreMapId);

    onToggleModal(visible, userStoreMapToEdit);
  }

  const actionButtons = (userStoreMapId: string) => {
    return (
      <Space>
        <EditOutlined className={'cursor-pointer hover:text-blue-dkt-400'}
                      onClick={() => handleFormModal(true, userStoreMapId)} />
      </Space>
    )
  };

  return (
    <>
      <Col md={24} xs={24} className={'mt-5'}>
        <FiltersComponent filterParameters={filterParameters}
                          onChangeFilters={(values) => setPaginationData({
                            pagination: { page, size },
                            filter: values
                          })} />
      </Col>
      <TableComponent pageSize={size}
                      currentPage={page}
                      total={count}
                      dataSource={list}
                      scrollX={700}
                      rowKey={'userStoreMapId'}
                      columns={getTableColumns('userStoreMaps', actionButtons)}
                      onChangePage={(pagination) => {
                        setPaginationData({ ...paginationData, pagination:{page: pagination.page, size: pagination.size }});
                      }} />
    </>
  );
}

export default UserStoreMapsTable;
